<template>
    <div id="all-commands-container">
        <div>
            <h1>Command Index</h1>
        </div>
        <Vert
            :image="sponsor.imagePath"
            :title="sponsor.name"
            :description="sponsor.shortDesc"
            :url="sponsor.vertURL"
            style="margin-bottom: 1rem;"
        />

        <v-autocomplete
                solo
                clearable
                :allow-overflow=true
                background-color="#5b5b5b"
                elevation="5"
                v-model="model"
                :items="items"
                :filter="customSearchFilter"
                :menu-props="autocompleteMenuProps"
                label="Search All Commands"
                item-text="commandString"
                item-value="commandString"
        >
            <template v-slot:item="data">
                <v-list-item v-on:click="itemClicked(data.item.type, data.item.routerRef)" style="background-color: #5b5b5b">
                    <b>{{data.item.type}}</b>
                    <v-divider vertical style="margin: 0 10px"></v-divider>
                    <v-list-item-content>
                        <v-list-item-title v-html="data.item.title"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.commandString"></v-list-item-subtitle>
                    </v-list-item-content>

                </v-list-item>
            </template>
        </v-autocomplete>

        <div id="content-table-container">

            <v-card
                ripple
                elevation="5"
                class="command-link"
                v-for="(commandType, i) in allCommands"
                v-on:click="goToRoute(commandType.routerName)"
                :key="i"
            >
                <v-card-title>{{commandType.navTitle}}</v-card-title>
                <v-card-subtitle>{{commandType.commandsDescription}}</v-card-subtitle>
            </v-card>
        </div>

    </div>
</template>


<script>
import Vert from "./sub-components/Vert";
import {ALL_COMMANDS, ULTIMATE_ARRAY} from "../commands/CommandExports";
import SPONSORS from '../utils/Sponsors'


const updateSponsorIntervalMillis = 5000
let updateSponsorIntervalID

    export default {
        name: 'Commands',

        props: {
        },

        mounted() {
            window.scrollTo(0,0);

            this.sponsor = SPONSORS.random(SPONSORS.tiers.saph, 1)[0]
            updateSponsorIntervalID = window.setInterval(this.updateSponsors, updateSponsorIntervalMillis)
        },

        beforeDestroy() {
            window.clearInterval(updateSponsorIntervalID)
        },

        components: {
            Vert
        },

        data: () => ({
            allCommands: ALL_COMMANDS,
            items: ULTIMATE_ARRAY,
            model: "",
            sponsor: {}
        }),

        methods: {

            // Custom search filter that takes into account the command title, commandString, and commandType
            // eslint-disable-next-line no-unused-vars
            customSearchFilter: function(item, queryText, itemText){

                const command = item.commandString.toLowerCase()
                const commandName = item.title.toLowerCase()
                const commandType = item.type.toLowerCase()
                const searchText = queryText.toLowerCase()

                return command.indexOf(searchText) > -1 ||
                    commandName.indexOf(searchText) > -1 ||
                    commandType.indexOf(searchText) > -1
            },

            goToRoute: function (routeName) {
                this.$router.push({
                    path: "documentation/" + routeName.replace("Docs", ""),
                    params: {
                        topic: routeName.replace("Docs", ""),
                    }
                })
            },

            itemClicked(routeName, routerRef){

                let cleanRouteName = routeName.replace(" ", "") + "Docs"
                this.$router.push({
                    name: cleanRouteName,
                    params: {
                        topic: cleanRouteName.replace("Docs", ""),
                        goToReference: routerRef
                    }
                })
            },

            autocompleteMenuProps() {
                // default properties copied from the vuetify-autocomplete docs
                let defaultProps = {
                    closeOnClick: false,
                    closeOnContentClick: false,
                    disableKeys: true,
                    openOnClick: false,
                    maxHeight: 304
                };

                if (this.$vuetify.breakpoint.smAndDown) {
                    defaultProps.maxHeight = 130;
                    defaultProps.top = true;
                }
                return defaultProps;
            },

            updateSponsors() {
                this.sponsor = SPONSORS.random(SPONSORS.tiers.saph, 1)[0]
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    #all-commands-container {
        height: auto;;
        padding: 20px 20px 10px 20px;
        background-color: #292929;
    }
    
    h1 {
        align-self: flex-start;
        margin-bottom: 10px;
    }

    #content-table-container {
        margin-top: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .command-link {
        width: 100%;
        margin-bottom: 1rem;
        background-color: #404040;
    }

    /* > phone size (tablet size)  */
    @media screen and (min-width: 750px) {
        #all-commands-container {
            width: 90%;
            max-width: 1000px;
            margin: auto;
        }

        .command-link {
            width: 100%;
            height: 100%;
            margin-bottom: 1rem;
            background-color: #404040;
        }

        #content-table-container {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;

            column-gap: 1.5rem;
            row-gap: 1.5rem;

        }
    }

    /* > Tablet size (desktop size)  */
    @media screen and (min-width: 1200px) {
        #all-commands-container {
            width: 60%;
            max-width: 1000px;
            margin: auto;
        }
    }

</style>
